<template>
  <div class="box">
    <admin-box-item title="일정">
      <template #header-right-spot>
        <select class="input-border select-calendar" @click.stop.prevent v-model="calendarType">
          <option value="monthly">월간 일정</option>
          <option value="weekly">주간 일정</option>
        </select>
      </template>
      <!-- 캘린더 -->
      <product-reservation-monthly v-if="calendarType === 'monthly'" ref="monthly" :prod="prod"
                                   :reservePolicy="reservePolicy" :reservePrice="reservePrice"
                                   :selectorStocks="selectorStocks"
                                   :propDate="currentDate" @more="onMore"></product-reservation-monthly>
      <product-reservation-weekly v-else ref="weekly" :prod="prod"
                                  :reservePolicy="reservePolicy" :reservePrice="reservePrice"
                                  :selectorStocks="selectorStocks"
                                  :propDate="currentDate"></product-reservation-weekly>

      <!-- 저장되지 않은 상품의 경우 -->
      <block-negative v-if="!prod.id"
                      :center="true"
                      notTxt="상품 시간 설정을 위해서 먼저 저장해주세요."
                      button="저장하기"
                      @clicked="$emit('save')"></block-negative>
    </admin-box-item>
  </div>
</template>

<script>
  import BlockNegative from "./BlockNegative";
  import ProductReservationMonthly from "./ProductReservationMonthly";
  import ProductReservationWeekly from "./ProductReservationWeekly";

  export default {
    name: 'PanelProductReservation',
    components: {
      ProductReservationWeekly,
      ProductReservationMonthly,
      BlockNegative
    },
    props: {
      prod: {
        type: Object
      },
      reservePolicy: {
        type: Object
      },
      reservePrice: {
        type: Array
      },
      selectorStocks: {
        type: Array
      }
    },
    created() {
    },
    data() {
      return {
        calendarType: 'monthly',
        currentDate: undefined
      }
    },
    methods: {
      onMore() {
        this.calendarType = 'weekly';
      }
    },
    watch: {
      calendarType(n, o) {
        this.currentDate = this.$refs[o] ? this.$refs[o].currentDate.format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .negative
    background-color #FFF0EB
    color #ff5722
    font-size 13px
    line-height 18.82px
    padding 12px 16px
    display flex
    gap 0 12px
    img
      margin-top 2px
      height 16px
  .not-txt
    flex 1
    white-space pre-line
    padding-right 8px

  .select-calendar
    position absolute
    top -6px
    right 36px
    width 120px
    border 1px solid #ffcea6
</style>
